export default "__VITE_ASSET__CyZ7uPEy__"